import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import _ from 'lodash';
import { IFetchMarket, IMarket } from './market.type';

// Define the Location interface representing the structure of the user object returned by the API

export const fetchMarkets = ({
  page,
  limit,
  operatorId,
  locationId,
  startDate,
  endDate,
  inactive,
  order,
  orderBy,
  includeInactive,
}: IFetchMarket): Promise<AxiosResponse<IMarket[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.MARKET.GET_MARKET,
    params: {
      page,
      limit,
      operatorId,
      locationId,
      includeInactive,
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(inactive ? { inactive } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
    },
  });
};

export const fetchAllMarketsList = ({
  page = 1,
  limit = 10,
  operatorId = '',
  providerId = '',
  orderBy,
  order,
  name,
  sourceMarketId,
  inactive,
  includeInactive,
}: IFetchMarket): Promise<AxiosResponse<IFetchMarket, any>> => {
  let params: any = {
    page,
    limit,
    ...(orderBy ? { orderBy } : {}),
    ...(order ? { order } : {}),
    ...(name ? { name } : {}),
    ...(sourceMarketId ? { sourceMarketId } : {}),
    ...(inactive ? { inactive } : {}),
    ...(includeInactive ? { includeInactive } : {}),
  };

  // only ONE of providerId or operatorId
  if (providerId !== '') {
    params.providerId = providerId;
  } else if (operatorId !== '') {
    params.operatorId = operatorId;
  }
  if (!params.operatorId && !params.providerId) {
    params = {
      ...params,
      operatorId: 1, // Set operatorId to 1
    };
  }
  return axiosInventoryInstance({
    url: API_URL_CONFIG.MARKET.GET_MARKETS_LIST,
    params,
  });
};
